import { Button, Card, Tabs, message } from 'antd';
import React, { useState, useRef } from 'react';

import moment from 'moment';
import { LocalPersistence } from '../../../../../factories';
import Loading from '../../../../Loading';
import { savePolicyTax } from '../../../../../services/policy';
import TaxAdd from './TaxAdd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
const dateFormat = 'MM/DD/YYYY';

const { TabPane } = Tabs;
const GPAdd = (props: any) => {
  const [addLoading, setAddLoading] = useState(false);
  const detailAddRef = useRef<any>();
  const [disabledStatus, setDisabledStatus] = useState(true);

  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }
    detailAddRef.current.detailsForm
      .validateFields()
      .then(() => {
        setDisabledStatus(false);
      })
      .catch(() => {
        const errTotalNum = detailAddRef?.current?.detailsForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;

        if (errTotalNum === 0) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };
  const addSave = () => {
    detailAddRef.current.detailsForm
      .validateFields()
      .then(async (detailsValue: any) => {
        const addObj: any = {};
        addObj.name = detailsValue.name || '';
        addObj.startdate =
          (detailsValue.rating &&
            detailsValue.rating[0] &&
            moment(detailsValue.rating[0]).format(dateFormat)) ||
          '';
        addObj.enddate =
          (detailsValue.rating &&
            detailsValue.rating[1] &&
            moment(detailsValue.rating[1]).format(dateFormat)) ||
          '';
        addObj.taxtype = detailsValue.taxtype || '';
        addObj.type = detailsValue.type || '';
        addObj.chargetype = detailsValue.chargetype || '';
        addObj.chargeamount = detailsValue.charge || '';
        addObj.currency = detailsValue.currency || '';
        addObj.chargefrequency = detailsValue.chargefrequency || '';
        addObj.chargeunit = detailsValue.chargeunit || '';
        addObj.sequence = detailsValue.sequence || '';
        addObj.description = detailsValue.description || '';
        const get_session = new LocalPersistence('session');
        const session: any = await get_session.getSessionPersistence();
        const params = {
          supplier: session.supplier,
          propertyId: session.propertyId,
          property: {
            policies: {
              taxpolicy: [
                {
                  ...addObj,
                },
              ],
            },
          },
        };
        setAddLoading(true);
        savePolicyTax(params).then(
          (res) => {
            setAddLoading(false);
            if (res.result.success) {
              cancelHandle();
            } else {
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
            setAddLoading(false);
          }
        );
      });
  };
  const cancelHandle = async () => {
    detailAddRef.current.detailsForm.resetFields();
    detailAddRef.current.restoreErr();
    props.cancelEditable();
    await props.getPoliciesData('Taxes');
  };

  if (addLoading) return <Loading type="large" />;
  return (
    <>
      <Tabs defaultActiveKey={props.activeTabKey}>
        <TabPane
          tab="Detail"
          key="Detail"
        >
          <TaxAdd
            ref={detailAddRef}
            validateFieldsError={validateFieldsError}
            cancellationDetails={props.cancellationDetails}
          />
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onCancel={cancelHandle}
        onSave={addSave}
        disabledSave={disabledStatus}
      />
    </>
  );
};
export default GPAdd;
